import React from 'react';
export const TransformationSection = () => {
  return <section className="w-full py-20 bg-white" data-id="element-434">
      <div className="max-w-4xl mx-auto px-4" data-id="element-435">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16" data-id="element-436">
          MOJA TRANSFORMACJA
        </h2>
        <div className="mb-10" data-id="element-437">
          <div className="w-full bg-gray-200 h-2 rounded-full" data-id="element-438">
            <div className="bg-green-500 h-2 rounded-full w-full" data-id="element-439"></div>
          </div>
          <div className="flex justify-between mt-2 text-sm text-gray-500" data-id="element-440">
            <div data-id="element-441">DZIEŃ 1</div>
            <div data-id="element-442">DZIEŃ 2</div>
            <div data-id="element-443">DZIEŃ 3</div>
            <div data-id="element-444">DZIEŃ 14</div>
            <div data-id="element-445">DZIEŃ 21</div>
          </div>
        </div>
        <div className="space-y-12" data-id="element-446">
          <div className="flex" data-id="element-447">
            <div className="flex-shrink-0 mr-6" data-id="element-448">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-449">
                <span className="text-green-600 text-xl" data-id="element-450">📅</span>
              </div>
            </div>
            <div data-id="element-451">
              <h3 className="text-xl font-bold mb-2" data-id="element-452">
                DZIEŃ 1: Przestałam robić jego pranie - BEZ KŁÓTNI
              </h3>
              <p className="text-gray-600" data-id="element-453">
                Pierwszy raz od lat nie zrobiłam mu prania. Nie ogłosiłam tego,
                nie kłóciłam się. Po prostu przestałam. Czekałam na wybuch...
                ale zamiast tego, wieczorem sam wrzucił swoje rzeczy do pralki.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-454">
            <div className="flex-shrink-0 mr-6" data-id="element-455">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-456">
                <span className="text-green-600 text-xl" data-id="element-457">📅</span>
              </div>
            </div>
            <div data-id="element-458">
              <h3 className="text-xl font-bold mb-2" data-id="element-459">
                DZIEŃ 2: "Co TY chciałbyś przygotować?" - pierwsze zaskoczenie
              </h3>
              <p className="text-gray-600" data-id="element-460">
                Zamiast gotować obiad jak zawsze, zapytałam go, co chciałby
                przygotować. Spojrzał na mnie zdziwiony. Po chwili konsternacji
                zaproponował, że zrobi makaron. Jedliśmy razem, rozmawiając
                pierwszy raz od miesięcy.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-461">
            <div className="flex-shrink-0 mr-6" data-id="element-462">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-463">
                <span className="text-green-600 text-xl" data-id="element-464">📅</span>
              </div>
            </div>
            <div data-id="element-465">
              <h3 className="text-xl font-bold mb-2" data-id="element-466">
                DZIEŃ 3: Poszłam SAMA na spacer - pierwszy raz od lat
              </h3>
              <p className="text-gray-600" data-id="element-467">
                Powiedziałam, że idę na spacer. Sama. Bez dzieci, bez niego.
                Tylko ja i moje myśli. Gdy wróciłam, czekał w kuchni. "Martwiłem
                się" - powiedział. Pierwszy raz od lat poczułam, że mnie widzi.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-468">
            <div className="flex-shrink-0 mr-6" data-id="element-469">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-470">
                <span className="text-green-600 text-xl" data-id="element-471">📅</span>
              </div>
            </div>
            <div data-id="element-472">
              <h3 className="text-xl font-bold mb-2" data-id="element-473">
                DZIEŃ 14: Pierwszy raz sam zainicjował rozmowę
              </h3>
              <p className="text-gray-600" data-id="element-474">
                Siedziałam w salonie z książką, gdy przysiadł się obok mnie. "Co
                czytasz?" - zapytał. To on zaczął rozmowę. Pierwszy raz od
                miesięcy. Rozmawialiśmy prawie dwie godziny, jak kiedyś, na
                początku.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-475">
            <div className="flex-shrink-0 mr-6" data-id="element-476">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-477">
                <span className="text-green-600 text-xl" data-id="element-478">📅</span>
              </div>
            </div>
            <div data-id="element-479">
              <h3 className="text-xl font-bold mb-2" data-id="element-480">
                DZIEŃ 21: "Dziękuję za wszystko" - ŁZY SZCZĘŚCIA
              </h3>
              <p className="text-gray-600" data-id="element-481">
                Dziś rano, przy śniadaniu, spojrzał mi w oczy i powiedział:
                "Dziękuję za wszystko, co robisz". Łzy napłynęły mi do oczu. Nie
                z żalu, ale ze szczęścia. Byłam widziana. Byłam doceniona. Byłam
                kochana.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};